<template src="./soltak.html"></template>

<script>
import store from './store';
import RoofType from './components/RoofType';
import NumPanels from './components/NumPanels';
import PanelSelector from './components/PanelSelector';
import CustomerInformation from './components/CustomerInformation';
import LoadingIndicator from './components/LoadingIndicator';
import MobilePriceDrilldown from './components/MobilePriceDrilldown';
import StartPage from './components/StartPage';
import CustomerType from './components/CustomerType';
import Summary from './components/Summary';
import Navigation from './components/Navigation';
import Sidepanel from './components/Sidepanel';
import SmsLogin from './components/SmsLogin';
import ContactInformation from './components/ContactInformation';

export default {
  name: 'HkraftSoltak',
  components: {
    RoofType,
    NumPanels,
    PanelSelector,
    CustomerInformation,
    LoadingIndicator,
    MobilePriceDrilldown,
    StartPage,
    CustomerType,
    Summary,
    Navigation,
    Sidepanel,
    SmsLogin,
    ContactInformation,
  },
  data() {
    return {
      showModal:
        false && new Date() > new Date(Date.UTC(2020, 7, 21, 19, 0, 0)),
    };
  },
  mounted() {
    window.onpopstate = function(event) {
      if (event.state) {
        store.commit('setCurrentPageIndex', event.state.currentPageIndex);
      }
    };
  },
  methods: {
    nextPage() {
      this.$root.$emit('navigateToNextPage');
    },
    previousPage() {
      this.$root.$emit('navigateToPreviousPage');
    },
  },
  computed: {
    currentPageIndex() {
      return store.state.currentPageIndex;
    },
    panel() {
      return store.state.panelsVal;
    },
    showIntro() {
      return store.state.showIntro;
    },
    roof() {
      return store.state.roof;
    },
    customerInformationValid() {
      return store.state.CustomerInformationValid;
    },
    agreedToTerms() {
      return store.state.CustomerInformation.agreedToTerms;
    },
    isOfferSubmitted() {
      return store.state.isOfferSubmitted;
    },
    isNextButtonDisabled() {
      return store.getters.isNextButtonDisabled;
    },
    nextButtonText() {
      return store.getters.nextButtonText;
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.form {
  position: relative;
}

.btn {
  margin-right: 0.3em;
}

.btn:hover,
.soltak-chat-btn:hover {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.4) !important;
}

.btn-solid.btn-hk-blue-deep {
  background-color: #003451;
  border-color: #003451;
}

.btn-arrow:after {
  margin-top: -3px;
}

.btn-arrow-left {
  text-align: right;
}

.btn-arrow-left:after {
  content: url("data:image/svg+xml;charset=UTF-8, <svg xmlns='http://www.w3.org/2000/svg' version='1.2' viewBox='0 0 24 24' height='30' width='30'><path fill='%23ffffff' d='M12,20l1.4-1.4L7.8,13H20v-2H7.8l5.6-5.6L12,4l-8,8L12,20z'/></svg>");
  float: left;
  margin-right: 0.5em;
  height: 0;
  opacity: 0;
  width: 0;
  margin-top: -3px;
  transition: opacity 0.3s, width 0.3s;
}

.btn-arrow-left:hover:after {
  width: 30px;
  opacity: 1;
}

.btn-solid.btn-green {
  background-color: #67bea2;
  border-color: #67bea2;
}

@media (max-width: 47.99em) {
  .form-info,
  .hide--mobile {
    display: none !important;
  }
}

.form__wrapper.select {
  padding-top: 5rem;
}

@media (max-width: 48em) {
  .form__wrapper.select {
    padding-top: 11rem;
  }
}

.form__pages {
  padding: 0;
}

@media (min-width: 48em) {
  .form-navigation-margin {
    margin-top: 4rem;
  }

  .summary-page-desktop {
    width: 65%;
    margin: 0 auto;
  }
}

.form__pages--page {
  padding: 0 2em;
}

.navigation {
  position: fixed;
  z-index: 40;
  background-color: #fff;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 16px;
  box-shadow: 0 -5px 15px 0 rgba(0, 0, 0, 0.4);
}

@media (min-width: 48em) {
  .navigation {
    top: 90px;
    bottom: unset !important;
  }
}

.form .navigation .btn {
  margin-top: 1em;
}

.navigation-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 2em;
  visibility: hidden;
}

.navigation-buttons.center {
  margin: 2rem auto 0;
  justify-content: center;
}

@media (min-width: 48em) {
  .navigation-buttons {
    visibility: visible !important;
  }
}

.form {
  color: #003451;
}

.form.select {
  margin-bottom: 2em;

  color: #003451;
}

.relative {
  position: relative;
}

.selectable-boxes {
  height: 4rem;
  line-height: 4rem;
  margin-bottom: 1rem;
  padding: 0 1rem;
  transition: background-color 0.1s ease-out, border-color 0.1s ease-out,
    box-shadow 0.1s ease-out;
  font-weight: 500;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
.selectable-boxes::after {
  content: '';
  background-image: url('./assets/bg_paper_light.png');
  background-size: auto;
  background-repeat: repeat;
  opacity: 0.8;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.selectable-boxes.selected,
.selectable-boxes:hover {
  border: 0.1rem solid #003451;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.4);
  transition: background-color 0.1s ease-out, border-color 0.1s ease-out,
    box-shadow 0.1s ease-out;
  font-weight: 600;
}

@media (min-width: 48em) {
  .selectable-boxes-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: flex-end;
  }

  :not(.selectable-boxes-wrapper) > .selectable-boxes,
  .selectable-boxes-wrapper {
    width: calc(50% - 0.5rem);
  }

  .selectable-boxes-wrapper:hover .recommended-tab {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.4);
    transition: box-shadow 0.1s ease-out;
  }
}

.selectable-boxes div {
  line-height: normal;
}

.selectable-boxes i {
  position: absolute;
  right: 1rem;
}

.selectable-boxes:not(.selected) i {
  visibility: hidden;
}

.selectable-boxes .selectable-boxes-secondary-text {
  font-size: 12px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s ease-out;
  color: #003451;
  z-index: 40;
}

.modal.is-visible {
  visibility: visible;
  opacity: 1;
}

.modal-dialog {
  position: relative;
  max-width: 800px;
  background-color: transparent;
  overflow: hidden;
  cursor: default;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.4);
}

@media (min-width: 48em) {
  .modal-dialog {
    min-width: 30rem;
  }
}

.modal-dialog > * {
  padding: 1rem;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #003451;
  color: #fff;
  height: auto;
}

.modal-header .close-modal {
  font-size: 1.5rem;
  color: #fff;
  background-color: #003451;
  border: none;
  cursor: pointer;
}

.modal-content {
  padding: 2rem;
  background-color: #fff;
  overflow: auto;
  max-height: 57vh;
}

.modal-content i {
  font-size: inherit;
  line-height: inherit;
}

input,
textarea {
  margin-bottom: 1rem;
  background-color: #e8f2fa;
  font-weight: 500;
  border: 0.1rem solid transparent !important;
  font-size: 16px !important;
}

input {
  height: 3rem;
  line-height: 3rem;
}

textarea {
  height: 8rem;
  line-height: 1.5;
}

input:focus,
textarea:focus {
  border: 0.1rem solid #003451 !important;
  outline: none !important;
}

label {
  font-size: 16px;
}

.mb-0 {
  margin-bottom: 0 !important;
}
</style>
